<h3 class="with-manual-link">
  <span i18n="@@feedback">Feedback</span>
  <app-manual-link
  href="https://reflact.github.io/engine/Handbuch/Nutzeroberfläche/Bot-Verwaltung/Insights/Feedback"></app-manual-link>
</h3>

<p
  class="text-secondary mt-1 mb-1"
  i18n="@@feedback-tab-description"
  >
  Die Feedback-Funktion ermöglicht es Nutzern, direkt im Chat Rückmeldungen zu geben, indem sie einen Daumen hoch oder
  einen Daumen runter verwenden. Dieses Feedback wird dann hier gesammelt und angezeigt, sodass es für Auswertungen oder
  Analysen genutzt werden kann.
</p>

<app-form-for-boolean
  [label]="this.humanFeedback"
  [(value)]="this.rss.botConfig.enableMessageFeedback"
  (valueChange)="this.rss.saveBotConfigField('enableMessageFeedback')"
></app-form-for-boolean>

@if (this.feedback.length !== 0) {
  <div
    class="btn-group btn-group-sm mb-3 mt-5"
    >
    <p-button
      type="button"
      size="small"
      [label]="'Alle'"
      [severity]="this.filter === 'all' ? 'primary' : 'secondary'"
      (onClick)="this.filter = 'all'"
      i18n-label="@@all"
    ></p-button>
    <p-button
      type="button"
      size="small"
      [label]="'Positiv'"
      [severity]="this.filter === 'thumbsup' ? 'primary' : 'secondary'"
      (onClick)="this.filter = 'thumbsup'"
      i18n-label="@@positive"
    ></p-button>
    <p-button
      type="button"
      size="small"
      [label]="'Negativ'"
      [severity]="this.filter === 'thumbsdown' ? 'primary' : 'secondary'"
      (onClick)="this.filter = 'thumbsdown'"
      i18n-label="@@negative"
    ></p-button>
  </div>
}

<div
  class="mt-2"
  [@.disabled]="true"
  >
  @if (this.feedback.length === 0) {
    <p-message
      severity="secondary"
      [closable]="false"
      i18n="@@no-feedbacks-found"
      >
    Noch kein Feedback eingegangen.
  </p-message>
  }
</div>

@for (feedback of this.feedback; track feedback) {
  <div>
    @if (feedback.remark === this.filter || this.filter === 'all') {
      <p-card
        styleClass="px-0 mb-3 shadow-sm"
        [ngClass]="{'card-light-danger': feedback.remark === 'thumbsdown'}"
        >
        <ng-template pTemplate="header">
          <div class="text-end justify-content-between d-flex p-3 pb-0">
            <i
              class="me-1 ri-2x"
          [ngClass]="{
            'ri-thumb-up-fill text-primary': feedback.remark === 'thumbsup',
            'ri-thumb-down-fill text-danger': feedback.remark === 'thumbsdown'
          }"
            ></i>
            {{ feedback.created | date }}
          </div>
        </ng-template>
        <div class="mt-0 pt-0">
          @for (message of feedback.messages; track message; let i = $index) {
            <div>
              @if (message.role !== 'botcard') {
                <app-message-bubble
                  [message]="message"
                  [bot]="this.rss.botConfig"
                  [botChatMsgSourceOption]="this.rss.botConfig.chatMsgSourceOption"
                  [voiceOutputActive]="false"
                  [isThinking]="false"
                ></app-message-bubble>
              }
            </div>
          }
        </div>
      </p-card>
    }
  </div>
}